
/* ============================================================
   THE HOME TEAM — Custom Theme JS
   Add to: Assets > hometeam.js
   Then include in layout/theme.liquid before </body>:
   {{ 'hometeam.js' | asset_url | script_tag }}
   ============================================================ */
// Add template class to body based on URL

(function() {
  'use strict';

  // ── CUSTOM CURSOR ──────────────────────────────────────────
  function initCursor() {
    if (window.innerWidth <= 768) return;
    const cursor = document.getElementById('ht-cursor');
    const ring = document.getElementById('ht-cursor-ring');
    if (!cursor || !ring) return;

    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top = my + 'px';
    });
    (function anim() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      requestAnimationFrame(anim);
    })();

    document.querySelectorAll('a, button, .ht-tier, .ht-bundle__card, .ht-product-card, .ht-scroll-arrow, .ht-cat-tab, .ht-testimonial-card, .ht-upsell-item').forEach(el => {
      el.addEventListener('mouseenter', () => { cursor.classList.add('hover'); ring.classList.add('hover'); });
      el.addEventListener('mouseleave', () => { cursor.classList.remove('hover'); ring.classList.remove('hover'); });
    });
  }

  // ── SCROLL REVEAL ──────────────────────────────────────────
  function initReveal() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('ht-visible'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.ht-reveal').forEach(el => obs.observe(el));
  }

  // ── BUNDLE TIERS ───────────────────────────────────────────
  function initBundleTiers() {
    document.querySelectorAll('.ht-tier').forEach(tier => {
      tier.addEventListener('click', () => {
        document.querySelectorAll('.ht-tier').forEach(t => t.classList.remove('active'));
        tier.classList.add('active');
      });
    });
  }

  // ── PRODUCT TABS ───────────────────────────────────────────
  function initProductTabs() {
    document.querySelectorAll('.ht-cat-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const cat = tab.dataset.cat;
        document.querySelectorAll('.ht-cat-tab').forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        document.querySelectorAll('.ht-product-card').forEach(card => {
          card.style.display = (cat === 'all' || card.dataset.cat === cat) ? 'block' : 'none';
        });
        const track = document.getElementById('ht-products-track');
        if (track) track.scrollLeft = 0;
      });
    });
  }

  // ── PRODUCT SCROLL ARROWS ──────────────────────────────────
  function initScrollArrows() {
    const track = document.getElementById('ht-products-track');
    if (!track) return;
    document.querySelectorAll('.ht-scroll-arrow').forEach(arrow => {
      arrow.addEventListener('click', () => {
        track.scrollBy({ left: parseInt(arrow.dataset.dir) * 600, behavior: 'smooth' });
      });
    });

    // Drag to scroll
    let isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', e => { isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft; });
    track.addEventListener('mouseleave', () => isDown = false);
    track.addEventListener('mouseup', () => isDown = false);
    track.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX) * 1.5;
    });
  }

  // ── CART DRAWER ────────────────────────────────────────────
  // Free shipping progress lives in ht-promos.js (gated by the free_shipping_enabled theme setting).
  // Totals here must match checkout, so no discounts are calculated in the drawer.

  function openHTCart() {
    const overlay = document.getElementById('ht-cart-overlay');
    const drawer = document.getElementById('ht-cart-drawer');
    if (overlay) overlay.classList.add('open');
    if (drawer) drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchAndRenderCart();
  }

  function closeHTCart() {
    const overlay = document.getElementById('ht-cart-overlay');
    const drawer = document.getElementById('ht-cart-drawer');
    if (overlay) overlay.classList.remove('open');
    if (drawer) drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  function fetchAndRenderCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderHTCart(cart))
      .catch(err => console.error('HT Cart error:', err));
  }

  function renderHTCart(cart) {
    const itemsEl = document.getElementById('ht-cart-items');
    const countEl = document.getElementById('ht-cart-count');
    const drawerCountEl = document.getElementById('ht-drawer-count');
    const footerEl = document.getElementById('ht-cart-footer');
    const shippingBar = itemsEl ? itemsEl.parentNode.querySelector('[data-ht-fs]') : null;
    const upsellEl = document.getElementById('ht-cart-upsell');

    const totalItems = cart.item_count;
    const subtotal = cart.total_price; // in cents, after any automatic discounts

    // Update nav dot
    if (countEl) {
      countEl.textContent = totalItems;
      countEl.style.background = totalItems > 0 ? 'var(--ht-gold)' : 'var(--ht-dark)';
    }
    if (drawerCountEl) drawerCountEl.textContent = totalItems;

    // Empty state
    const isEmpty = totalItems === 0;
    if (itemsEl) itemsEl.style.display = isEmpty ? 'none' : '';
    if (footerEl) footerEl.style.display = isEmpty ? 'none' : '';
    if (shippingBar) shippingBar.style.display = isEmpty ? 'none' : '';
    if (upsellEl) upsellEl.style.display = isEmpty ? 'none' : '';

    const emptyEl = document.getElementById('ht-cart-empty');
    if (emptyEl) emptyEl.style.display = isEmpty ? 'flex' : 'none';

    if (isEmpty || !itemsEl) return;

    // Shipping progress
    if (window.htUpdateFreeShipping) window.htUpdateFreeShipping(cart);

    // Line items
    itemsEl.innerHTML = cart.items.map(item => `
      <div class="ht-cart-item" data-key="${item.key}">
        <div class="ht-cart-item__img">
          <img src="${item.image}" alt="${item.title}" loading="lazy" />
        </div>
        <div>
          <div class="ht-cart-item__name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="ht-cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="ht-cart-item__bottom">
            <div class="ht-cart-item__price">$${(item.line_price / 100).toFixed(2)}</div>
            <div style="display:flex;align-items:center;">
              <button class="ht-qty-btn" onclick="htChangeQty('${item.key}', ${item.quantity - 1})">−</button>
              <div class="ht-qty-display">${item.quantity}</div>
              <button class="ht-qty-btn" onclick="htChangeQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
          <button class="ht-cart-item__remove" onclick="htChangeQty('${item.key}', 0)">Remove</button>
        </div>
      </div>
    `).join('');

    // Summary
    const subtotalEl = document.getElementById('ht-subtotal-val');
    const totalValEl = document.getElementById('ht-total-val');
    if (subtotalEl) subtotalEl.textContent = '$' + (subtotal/100).toFixed(2);
    if (totalValEl) totalValEl.textContent = '$' + (subtotal/100).toFixed(2);
  }

  window.htChangeQty = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => renderHTCart(cart));
  };

  window.htAddToCart = function(variantId, qty) {
    qty = qty || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(() => { openHTCart(); })
    .catch(err => console.error('Add to cart error:', err));
  };

  window.openHTCart = openHTCart;
  window.closeHTCart = closeHTCart;

  // ── MOBILE MENU ─────────────────────────────────────────────
  function initMobileMenu() {
    const btn = document.getElementById('ht-mobile-menu-btn');
    const menu = document.getElementById('ht-mobile-menu');
    if (!btn || !menu) return;
    btn.addEventListener('click', () => {
      menu.classList.toggle('open');
      document.body.style.overflow = menu.classList.contains('open') ? 'hidden' : '';
    });
  }

  // ── KEYBOARD ────────────────────────────────────────────────
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeHTCart();
  });

  // ── CART TRIGGER — intercept Shopify cart links ─────────────
  document.addEventListener('click', e => {
    const cartTrigger = e.target.closest('[data-ht-cart-trigger]');
    if (cartTrigger) {
      e.preventDefault();
      openHTCart();
    }
  });

  // ── INIT ────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    initCursor();
    initReveal();
    initBundleTiers();
    initProductTabs();
    initScrollArrows();
    initMobileMenu();
  });

})();
